module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "spart",
    attrs: {
      "epub:type": "division",
      "id": "spart-002"
    }
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_34",
      "title": "34"
    }
  }, [_c('div', {
    staticClass: "spart_debut"
  }), _c('div', {
    staticClass: "dev"
  }, [_c('figure', {
    staticClass: "fig",
    attrs: {
      "id": "fig-004"
    }
  }, [_c('div', {
    staticClass: "image"
  }, [_c('img', {
    staticClass: "image",
    attrs: {
      "alt": "Coleridge’s rooms at Jesus College Cambridge: “I became a proverb to the University for Idleness—the time, which I should have bestowed on the academic studies, I employed in dreaming out wild schemes of impossible extrication.”",
      "src": "images/pg_34_college.jpg"
    }
  })]), _c('figcaption', {
    staticClass: "leg"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Coleridge’s rooms at Jesus College Cambridge: “I became a proverb to the University for Idleness—the time, which I should have bestowed on the academic studies, I employed in dreaming out wild schemes of impossible extrication.”")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-50cabedc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1sp2.vue
// module id = 84
// module chunks = 0